import { Box, StyleProps } from "@chakra-ui/react";
import clsx from "clsx";
import React from "react";
import {
  PageContentContextProvider,
  usePageContentContext,
} from "shared/components/layout/PageContentContext";
import { ScrollBottomPaddingHack } from "shared/components/layout/ScrollBottomPaddingHack";

export interface PageTabBodyProps extends StyleProps {
  isFullHeight?: boolean;
}

export const PageTabBody: React.FC<
  React.PropsWithChildren<PageTabBodyProps>
> = ({ isFullHeight: isFullHeightProp, children, ...props }) => {
  const bodyContext = usePageContentContext();
  const isFullHeight = isFullHeightProp ?? bodyContext.isFullHeight;
  return (
    <PageContentContextProvider isFullHeight={isFullHeight}>
      <Box
        mx="-24px"
        px="24px"
        pt="16px"
        className={clsx({
          "mb-page-tab-body": true,
          "mb-page-tab-body-full-height": isFullHeight,
        })}
        sx={{
          ".mb-page-tabs-hidden &": {
            pt: 0,
          },
          ...(isFullHeight
            ? {
                display: "flex",
                minHeight: 0,
                flexDirection: "column",
              }
            : undefined),
        }}
        {...props}
      >
        {children}
        <ScrollBottomPaddingHack />
      </Box>
    </PageContentContextProvider>
  );
};
